import { request } from '@pb/utils'

import { API_ENDPOINTS } from 'App/constants'

import {
  getArticlesPath,
  getRecommendationPath,
} from './components/OrderDetailsPage/StyleYourLatestCarousel/constants'
import { ORDER_STATUSES } from './constants'

export interface FetchOnlineOrdersParams {
  start: number
  end: number
  active?: boolean
}

const fetchOnlineOrders = ({ start = 0, end = 5, active }: FetchOnlineOrdersParams): Promise<any> =>
  request
    .get('orders', {
      apiVersion: 2,
      params: {
        start,
        end,
        active,
      },
    })
    .then((res) => res.data)

const fetchOnlineOrder = (orderId): any => {
  if (!orderId) {
    throw new Error('orderId need to be provided to fetchOnlineOrder')
  }

  return request.get(`orders/${orderId}`, { apiVersion: 3 }).then((res) => res)
}
const fetchRecommendations = (userBpid): any => {
  return request
    .get(getRecommendationPath(userBpid), {
      use: { apiVersion: false, locale: false },
    })
    .then((res) => res)
}

const fetchArticles = (sortedRecommendations): any => {
  return request
    .get(getArticlesPath(sortedRecommendations), {
      use: { apiVersion: false, locale: true },
    })
    .then((res) => res)
}

const fetchStoreOrders = (start = 0, end = 5): Promise<any> =>
  request
    .get('inStoreOrders', {
      apiVersion: 2,
      params: {
        start,
        end,
      },
    })
    .then((res) => res.data)

const fetchStoreOrder = (orderId): any => {
  if (!orderId) {
    throw new Error('orderId need to be provided to fetchStoreOrder')
  }

  return request.get(`inStoreOrders/${orderId}`).then((res) => res)
}

const fetchStoreOrdersAddresses = (storeIds): any => {
  if (!storeIds) {
    throw new Error('storeIds need to be provided to fetchOrdersStoreAddresses')
  }

  return request.get(API_ENDPOINTS.storeLocator + storeIds.join()).then((res) => res.data)
}

const cancelOnlineOrder = (orderId): any => {
  if (!orderId) {
    throw new Error('You need to provide an order id to cancel')
  }
  return request
    .put(`orders/${orderId}`, {
      data: {
        status: ORDER_STATUSES.CANCELLED,
      },
    })
    .then((res) => res)
}

const addToBag = async (quantity, variantCode): Promise<any> => {
  const response = await request.post('carts/items', {
    data: { quantity, variantCode },
  })
  return response.data
}

export default {
  fetchOnlineOrders,
  fetchOnlineOrder,

  fetchStoreOrdersAddresses,
  fetchStoreOrders,
  fetchStoreOrder,

  cancelOnlineOrder,

  fetchRecommendations,
  fetchArticles,
  addToBag,
}
